import React from 'react'
import {
  Flag as ExceptionIcon,
  Map as RegionIcon,
  People as PeopleIcon,
  RuleFolder as MastersIcon,
} from '@mui/icons-material'
import AdminLandingPage, {
  type AdminLandingCard,
} from '../../components/admin/AdminLandingPage'

const cards: AdminLandingCard[] = [
  {
    icon: ExceptionIcon,
    title: 'Exception Setup',
    description:
      'Manage exception rules, classification, visibility and health scoring across all franchise partners',
    to: '/admin/system/exception-setup',
    buttonLabel: 'Open Exception Setup',
  },
  {
    icon: RegionIcon,
    title: 'Manage Regions',
    description:
      'Configure franchise regions and assign default ROM/FBC for each region',
    to: '/admin/system/regions',
    buttonLabel: 'Manage Regions',
  },
  {
    icon: MastersIcon,
    title: 'Poolwerx Master Lists',
    description:
      'View the master lists used by exception checks to verify each franchise partner has the right setup across systems',
    to: '/admin/system/pwx-masters',
    buttonLabel: 'Poolwerx Master Lists',
  },
  {
    icon: PeopleIcon,
    title: 'Manage ROM/FBC',
    description:
      'Manage Regional Operations Managers and Franchise Business Consultants',
    to: '/admin/system/bdm',
    buttonLabel: 'Manage ROM/FBC',
  },
]

const Settings: React.FC = () => (
  <AdminLandingPage pageKey="settings" cards={cards} />
)

export default Settings
